import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import RemindersAPI from '../../api/reminders';

// Mutation-types locais (não tocamos no mutation-types.js central -> isolado do core).
const types = {
  SET_REMINDER_UI_FLAG: 'SET_REMINDER_UI_FLAG',
  SET_REMINDERS: 'SET_REMINDERS',
  ADD_REMINDER: 'ADD_REMINDER',
  EDIT_REMINDER: 'EDIT_REMINDER',
  DELETE_REMINDER: 'DELETE_REMINDER',
};

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getReminders(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_REMINDER_UI_FLAG, { isFetching: true });
    try {
      const response = await RemindersAPI.get();
      commit(types.SET_REMINDERS, response.data);
    } finally {
      commit(types.SET_REMINDER_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, reminderObj) => {
    commit(types.SET_REMINDER_UI_FLAG, { isCreating: true });
    try {
      const response = await RemindersAPI.create({ reminder: reminderObj });
      commit(types.ADD_REMINDER, response.data);
    } finally {
      commit(types.SET_REMINDER_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    const response = await RemindersAPI.update(id, { reminder: updateObj });
    commit(types.EDIT_REMINDER, response.data);
  },
  delete: async ({ commit }, id) => {
    await RemindersAPI.delete(id);
    commit(types.DELETE_REMINDER, id);
  },
};

export const mutations = {
  [types.SET_REMINDER_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_REMINDERS]: MutationHelpers.set,
  [types.ADD_REMINDER]: MutationHelpers.create,
  [types.EDIT_REMINDER]: MutationHelpers.update,
  [types.DELETE_REMINDER]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
